/* ML-04 · READINESS GRID — real tier.
   The multi-location learning surface: one row per establishment, one column
   per thing that must be true before it can go live. Every cell leads to the
   missing action. */
import { Pill } from '@/ui'
import { useML } from './EtabShell'

export default function ML04Preparation() {
  const r = useML().readiness
  return (
    <section data-frame="ML-04" style={{ display: 'grid', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, flexWrap: 'wrap' }}>
        <h2 className="t-section" style={{ flex: 1 }}>Grille de préparation</h2>
        <span className="t-muted" style={{ fontSize: 12 }}>{r.crumb}</span>
      </div>
      <div className="tablewrap">
        <table className="tbl">
          <thead><tr>{r.columns.map(c => <th key={c}>{c}</th>)}</tr></thead>
          <tbody>
            {r.rows.map(row => (
              <tr key={row.name}>
                <td><strong>{row.name}</strong></td>
                {row.cells.map((c, i) => (
                  <td key={i}>
                    {typeof c === 'string'
                      ? c
                      : <Pill tone={c.tone} mark={c.mark}>{c.label}</Pill>}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="t-body">
        Conditions, plateforme, connexion Google, test de campagne, appareil équipe, support —
        chaque colonne cliquable vers l’action manquante.
      </p>
    </section>
  )
}
